var React = require('react');

function Business (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.322 9.646L10.229 12 9.196 7.561l3.448-2.986-4.546-.39L6.322 0 4.546 4.185 0 4.575l3.449 2.986L2.415 12z"}));
}

Business.defaultProps = {"width":"12.644","height":"12","viewBox":"0 0 12.644 12"};

module.exports = Business;

Business.default = Business;
